const DataBreadcrumb = ObjectBase.extend({

    render: function (context, el) {

        if (!el || !(el instanceof jQuery)) {
            return;
        }

        var proxy = $.proxy(this.getData, context);
        var data = proxy();

        if (!this.columns || !data) {
            return;
        }

        $.each(this.columns, function () {

            switch (this.type) {
                case 'Money':
                    this.value = global.formatMoney(data[this.prop]);
                    break;

                case 'Date':
                    this.value = global.formatDate(data[this.prop]);
                    break;
                    
                default:
                    this.value = data[this.prop];
            }
        });

        var template = '<div id="div-data-breadcrumb"> <table class="t3" data-breadcrumb>{{#columns}}<tr><th>{{title}}</th><td>{{value}}</td><tr>{{/columns}}</table> </div>';
        //var template = '<table class="t3" data-breadcrumb>{{#columns}}<tr><th>{{title}}</th><td>{{value}}</td><tr>{{/columns}}</table>';
        var html = Mustache.render(template, this);
        el.prepend(html);
    }

});

window.DataBreadcrumb = DataBreadcrumb

export {
    DataBreadcrumb
}